import { render, staticRenderFns } from "./TheSwitcher.vue?vue&type=template&id=316ad3c2&scoped=true&"
import script from "./TheSwitcher.vue?vue&type=script&lang=js&"
export * from "./TheSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./TheSwitcher.vue?vue&type=style&index=0&id=316ad3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ad3c2",
  null
  
)

export default component.exports